export default __webpack_public_path__ + "static/media/logo.395b406d.png";